:host {
  display: inline;
  width: initial;
  height: auto;
}

.counter {
  font-size: var(--body-size-xxlarge);
  color: var(--main-titles-inputs-600);
}
